// 最短日以前選択時に最短日時を返す
function checkPastDateAndHoliday(data, publicHolidayArray) {
    // 選択曜日
    // let selectedDate = dayjs(data.target_date).day();
    if (myDebugPrintFlag) {
        console.log("publicHolidayArray=" + publicHolidayArray);
    }

    let delivery_express_value;
    let newspaper_val;
    let now;

    if (myDebugPrintFlag) {
        console.log("選択済お届け希望日=" + data.target_date);
    }

    // お急ぎ便の値をセット
    if (data.delivery_express) {
        delivery_express_value = data.delivery_express;
    } else {
        // お急ぎ便選択フォームがない場合は全て通常
        delivery_express_value = "通常";
    }

    // 記念日新聞の値をセット
    if (data.newspaper) {
        newspaper_val = data.newspaper;
    } else {
        newspaper_val = "";
    }

    let days = getDays(
        delivery_express_value,
        { a: data.delivery_a, b: data.delivery_b },
        newspaper_val
    );
    days = days + holiday_add_days;

    // 最短日より過去の日付のチェック
    // 現在日付
    if (myDebugDateTime) {
        now = dayjs(myDebugDateTime);
    } else {
        now = dayjs();
    }

    // 今日が土日祝の場合は時間帯によって翌営業日にする
    if (now.day() !== 0 && now.day() !== 6 && !isHoliday(now)) {
        if (days === 1) {
            // 即日発送
            if (Number(now.format("H")) >= 12) {
                // 12時以降は翌日からカウントするのでプラス1日
                days = ++days;
            }
        } else {
            // 2営業日以降発送
            if (Number(now.format("H")) >= 15) {
                // 15時以降は翌日からカウントするのでプラス1日
                days = ++days;
            }
        }
    }

    if (myDebugPrintFlag) {
        console.log("受注時刻による追加日数加算後 = " + days);
    }

    // 追加日数分カウントアップする
    let i = 0;
    let c = 0;
    let targetChangeDate;
    while (c < days) {
        // 現在日付に１日ずつプラス
        if (i === 0) {
            targetChangeDate = now;
        } else {
            targetChangeDate = targetChangeDate.add(1, "days");
        }

        // 土日祝以外のみカウントアップ
        if (
            targetChangeDate.day() !== 0 &&
            targetChangeDate.day() !== 6 &&
            !isHoliday(targetChangeDate)
        ) {
            c++;
            if (myDebugPrintFlag) {
                console.log(c + "営業日");
            }
        } else {
            if (myDebugPrintFlag) {
                console.log("土日祝");
            }
        }
        if (myDebugPrintFlag) {
            console.log(targetChangeDate.format("YYYY-MM-DD"));
        }

        i++;
    }
    // 配送に1日かかると仮定して1日追加
    targetChangeDate = targetChangeDate.add(1, "days");

    if (myDebugPrintFlag) {
        console.log("data.delivery_min_date=" + data.delivery_min_date);
    }

    // 最短納期日付の `delivery_min_date` が設定されている場合
    if (
        data.delivery_min_date &&
        dayjs(data.delivery_min_date).diff(targetChangeDate, "days") > 0
    ) {
        // お届け希望日の `min`(targetChangeDate)より `delivery_min_date` の方が後の場合、targetChangeDateを `delivery_min_date` で上書き
        targetChangeDate = dayjs(data.delivery_min_date);
    }

    // 選択済みの場合
    if (data.target_date) {
        // 選択済みの日付が範囲外
        if (
            dayjs(data.target_date).diff(
                targetChangeDate.format("YYYY-MM-DD"),
                "days"
            ) < 0
        ) {
            return targetChangeDate.format("YYYY-MM-DD");
        }
    }

    return false;
}

function url_encode(string) {
    return encodeURIComponent(string + "")
        .replace(/!/g, "%21")
        .replace(/'/g, "%27")
        .replace(/\(/g, "%28")
        .replace(/\)/g, "%29")
        .replace(/\*/g, "%2A");
    // .replace(/%20/g, "+");
}

function queryStringToJson(queryString) {
    queryString = queryString.replace(/&amp;/g, "&");
    let pairs = queryString.split("&");
    let result = {};

    pairs.forEach((pair) => {
        let keyValue = pair.split("=");
        let key = decodeURIComponent(keyValue[0]);
        let value = decodeURIComponent(keyValue[1]);

        if (key.includes("[")) {
            let keys = key.split("[");
            let currentObject = result;
            keys.forEach((key, index) => {
                key = key.replace("]", "");
                if (index === keys.length - 1) {
                    if (!currentObject[key]) {
                        currentObject[key] = value;
                    } else {
                        if (!Array.isArray(currentObject[key])) {
                            currentObject[key] = [currentObject[key]];
                        }
                        currentObject[key].push(value);
                    }
                } else {
                    if (!currentObject[key]) {
                        currentObject[key] = {};
                    }
                    currentObject = currentObject[key];
                }
            });
        } else {
            result[key] = value;
        }
    });

    return result;
}
